import { useEffect, useMemo, useReducer } from "react";

import { buildVisitLocationClusters } from "./buildVisitLocationClusters";
import type { VisitLocation, VisitLocationCluster } from "./types";

export function useVisitLocationClusters(
  visitLocations: VisitLocation[],
  map: google.maps.Map | undefined
): VisitLocationCluster[] {
  const [recalculate, setRecalculate] = useReducer((value: number) => value + 1, 0);

  useEffect(() => {
    if (!map) {
      return undefined;
    }

    const zoomListener = map.addListener("zoom_changed", () => {
      setRecalculate();
    });

    const projectionListener = map.addListener("projection_changed", () => {
      setRecalculate();
    });

    return () => {
      zoomListener?.remove();
      projectionListener?.remove();
    };
  }, [map]);

  return useMemo(() => {
    if (!map) {
      return [];
    }

    return buildVisitLocationClusters({ map, visitLocations });
    // recalculate triggers re-computation on zoom/projection changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, visitLocations, recalculate]);
}
